import { Settings } from "lucide-react";
import { Button } from "@/components/ui/button";
import {
  DropdownMenu,
  DropdownMenuContent,
  DropdownMenuLabel,
  DropdownMenuRadioGroup,
  DropdownMenuRadioItem,
  DropdownMenuSeparator,
  DropdownMenuTrigger,
} from "@/components/ui/dropdown-menu";
import { useAutoSavePreference, AutoSaveInterval, getIntervalLabel } from "@/hooks/useAutoSavePreference";
import { toast } from "sonner";

export const AutoSaveSettings = () => {
  const { interval, setInterval } = useAutoSavePreference();

  const handleIntervalChange = (value: string) => {
    const newInterval = parseInt(value) as AutoSaveInterval;
    setInterval(newInterval);
    
    if (newInterval === 0) {
      toast.success("Auto-save disabled", {
        description: "You can still save manually using the Save Draft button"
      });
    } else {
      toast.success("Auto-save interval updated", {
        description: `Articles will now auto-save ${getIntervalLabel(newInterval).toLowerCase()}`
      });
    }
  };

  return (
    <DropdownMenu>
      <DropdownMenuTrigger asChild>
        <Button variant="outline" size="sm" className="gap-2">
          <Settings className="h-4 w-4" />
          Auto-save: {getIntervalLabel(interval)}
        </Button>
      </DropdownMenuTrigger>
      <DropdownMenuContent align="end" className="w-56">
        <DropdownMenuLabel>Auto-save Interval</DropdownMenuLabel>
        <DropdownMenuSeparator />
        <DropdownMenuRadioGroup value={interval.toString()} onValueChange={handleIntervalChange}>
          <DropdownMenuRadioItem value="15000">
            Every 15 seconds
          </DropdownMenuRadioItem>
          <DropdownMenuRadioItem value="30000">
            Every 30 seconds
          </DropdownMenuRadioItem>
          <DropdownMenuRadioItem value="60000">
            Every 60 seconds
          </DropdownMenuRadioItem>
          <DropdownMenuRadioItem value="0">
            Disabled
          </DropdownMenuRadioItem>
        </DropdownMenuRadioGroup>
      </DropdownMenuContent>
    </DropdownMenu>
  );
};
